import { render, staticRenderFns } from "./ReceiveShippingModal.vue?vue&type=template&id=21b37345&scoped=true"
import script from "./ReceiveShippingModal.vue?vue&type=script&lang=js"
export * from "./ReceiveShippingModal.vue?vue&type=script&lang=js"
import style0 from "./ReceiveShippingModal.vue?vue&type=style&index=0&id=21b37345&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b37345",
  null
  
)

export default component.exports